import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { InventoryPurchaseService } from "../../../core/services/inventory-purchase.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { FinishedGoodsTemplateGridComponent } from "../finished-goods-template-grid/finished-goods-template-grid.component";
import { ServiceTemplateGridComponent } from "../service-template-grid/service-template-grid.component";
import { FinishedGoodsTemplateHeader } from "../../../core/models/inventoryPurchases/finishedGoodsTemplateHeader";
import { AddAndUpdateFinishedGoodsTemplateDto } from "../../../core/models/inventoryPurchases/addAndUpdateFinishedGoodsTemplateDto";
import { FormGroup, FormsModule } from "@angular/forms";
import { ConfirmationService } from "primeng/api";
import { DeleteTemplateDto } from "../../../core/models/inventoryPurchases/deleteTemplateDto";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { ReleasedProductVariants } from "../../../core/models/shared/releasedProductVariants";
import { ReleasedProduct } from "../../../core/models/shared/releaseProduct";
import { LoaderService } from "../../../core/services/loader.service";
import { OrderSummaryService } from "../../../core/services/order-summary.service";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { CommonModule } from "@angular/common";
import { SelectModule } from "primeng/select";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { TemplateServiceLineFormComponent } from "../template-service-line-form/template-service-line-form.component";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { PurchaseOrderLine } from "../../../core/models/samplePO/details/purchaseOrderLine";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { CheckboxModule } from "primeng/checkbox";

@Component({
  selector: "jni-add-existing-finished-goods-template",
  templateUrl: "./add-existing-finished-goods-template.component.html",
  styleUrls: ["./add-existing-finished-goods-template.component.scss"],
  providers: [ConfirmationService],
  imports: [
    CommonModule,
    SelectModule,
    ServiceTemplateGridComponent,
    ModalStackerComponent,
    FormsModule,
    TemplateServiceLineFormComponent,
    ConfirmDialogModule,
    FinishedGoodsTemplateGridComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    CheckboxModule,
  ],
})
@UntilDestroy()
export class AddExistingFinishedGoodsTemplateComponent implements OnInit {
  @Input() parent!: FormGroup;
  @Input() saleOrderIdFromModal = "";
  @Input() lineGroup = "";
  @Input() site = "";
  @Input() warehouse = "";
  @Input() jobNameD365 = "";
  @Input() wMSLocationD365 = "";
  @Input() saleOrderModalStatus = false;
  @Input() owner = "";
  @Input() store = "";
  isSubmmited = false;

  @Output() refreshGridEmit = new EventEmitter();
  @Output() closeModalEmit = new EventEmitter();
  itemType = "";
  variables = "";

  templates: FinishedGoodsTemplateHeader[] = [];
  allTemplates: FinishedGoodsTemplateHeader[] = [];

  selectedTemplate!: FinishedGoodsTemplateHeader;

  header!: FinishedGoodsTemplateHeader;

  releasedProductsList: ReleasedProduct[] = [];
  allReleasedProductsList: ReleasedProduct[] = [];
  releasedProductsVariantsList: ReleasedProductVariants[] = [];
  allReleasedProductsVariantsList: ReleasedProductVariants[] = [];

  inventoryServiceLinesDisplayModal = false;

  size = false;
  color = false;
  fit = false;

  vendorReference = "";
  templateName = "";
  oldTemplateName = "";
  templateVendorReference = "";

  @ViewChild("finishedGoodsTemplateGrid", { static: false })
  finishedGoodsTemplateGrid!: FinishedGoodsTemplateGridComponent;

  @ViewChild("servicesTemplateGrid", { static: false })
  servicesTemplateGrid!: ServiceTemplateGridComponent;
  index!: number | null;
  serviceLineToEdit!: PurchaseOrderLine;

  constructor(
    private _inventoryPurchaseService: InventoryPurchaseService,
    private _toastr: JniToastrService,
    private _loader: LoaderService,
    private _orderSummaryService: OrderSummaryService,
    private _samplepoListingService: SamplepoListingService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.getFinishedGoodsTemplateNames();
    this.getAllReleaseProduct();
    this.getAllVariants();
  }

  templateChange() {
    this.getFinishedGoodsTemplate();
  }

  getFinishedGoodsTemplateNames() {
    this._loader.setLoaderState(true);
    this._inventoryPurchaseService
      .getFinishedGoodsTemplateNames()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<FinishedGoodsTemplateHeader[]>) => {
          this._loader.setLoaderState(false);
          this.templates = res.data.filter(x => x.store == this.store);
          this.allTemplates = res.data.filter(x => x.store == this.store);
        },
        error: () => {
          this._loader.setLoaderState(false);
          this._toastr.error(
            "Something went wrong while fetching templates",
            "Error"
          );
        },
      });
  }

  getFinishedGoodsTemplate() {
    this._loader.setLoaderState(true);
    this._inventoryPurchaseService
      .getFinishedGoodsTemplate(this.selectedTemplate.id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loader.setLoaderState(false);
          if (res.data) {
            if (res.data.finishedGoodsTemplateHeader) {
              this.header = res.data.finishedGoodsTemplateHeader;
              this.selectedTemplate.name = this.header.name;
              this.itemType = this.header.itemType;
              this.templateName = this.header.name;
              this.oldTemplateName = this.header.name;
              this.templateVendorReference = this.header.vendorReference;
              this.vendorReference = this.header.vendorReference;
              this.fit = this.header.fit;
              this.color = this.header.color;
              this.size = this.header.size;
              this.variables = "";
              if (this.header.fit) {
                this.variables = `Style`;
              }
              if (this.header.size) {
                this.variables = this.variables
                  ? `${this.variables}, Size`
                  : `Size`;
              }
              if (this.header.color) {
                this.variables = this.variables
                  ? `${this.variables}, Color`
                  : `Color`;
              }
            }

            const lines = res.data
              .finishedGoodsTemplateLines as unknown as PurchaseOrderLine[];

            this.setLines(lines);
          }
        },
        error: () => {
          this._loader.setLoaderState(false);
          this._toastr.error(
            "Something went wrong while fetching template",
            "Error"
          );
        },
      });
  }

  setLines(lines: PurchaseOrderLine[]) {
    this.finishedGoodsTemplateGrid.filteredFinishedGoodsList = [];
    this.servicesTemplateGrid.filteredServiceLines = [];

    this.finishedGoodsTemplateGrid.filteredFinishedGoodsList = lines.filter(
      x => x.parentD365
    );

    const finishedGoodListTemp = lines.filter(x => x.parentD365);

    this.finishedGoodsTemplateGrid.filteredFinishedGoodsList =
      finishedGoodListTemp.map(item => {
        return {
          ...item,
          purchasePriceD365: item.purchasePriceD365 ?? 0,
          lineAmountD365: item.lineAmountD365 ?? 0,
        };
      });
    // this.finishedGoodsTemplateGrid.filteredFinishedGoodsList = finishedGoodListTemp.map((item) =>{
    //   let obj = this.releasedProductsList.filter((it) => it.itemNumberD365 === item.itemNumberD365)[0];
    //   return {
    //     ...item,
    //     mockSellD365: obj.salesPriceD365,
    //     mockSellTotalD365: (obj.salesPriceD365 || 0) * (item.orderedPurchaseQuantityD365 || 1),
    //   }
    // })
    this.servicesTemplateGrid.filteredServiceLines = lines.filter(
      x => !x.parentD365
    );
  }

  getAllReleaseProduct() {
    this._orderSummaryService
      .getAllCategory()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.allReleasedProductsList = res.data?.filter(
            x => x.productTypeD365 !== "Service" && x.poStopped === "No"
          );

          this.finishedGoodsTemplateGrid.allReleasedProductsList =
            this.allReleasedProductsList;

          this.releasedProductsList = [
            ...this.allReleasedProductsList.filter(
              x => x.ownerD365 == this.owner
            ),
          ];

          this.finishedGoodsTemplateGrid.releasedProductsList =
            this.releasedProductsList;

          // this.releasedProductsList = this.allReleasedProductsList?.filter(
          //   (x) => x.ownerD365 == this.owner
          // );
        },
      });
  }

  getAllVariants() {
    this._loader.setLoaderState(true);
    this._samplepoListingService
      .getAllVariants()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loader.setLoaderState(false);
          this.allReleasedProductsVariantsList = res.data.filter(
            item => item.poStopped === "No"
          );
          this.releasedProductsVariantsList = [
            ...this.allReleasedProductsVariantsList,
          ];

          this.finishedGoodsTemplateGrid.releasedProductsVariantsList =
            this.releasedProductsVariantsList;
        },
      });
  }

  createTemplate() {
    if (!this.header) {
      this._toastr.error("No Template Selected", "Error");
      return;
    }
    const header = this.header;
    header.id = 0;
    header.vendorReference = this.vendorReference;
    header.name = this.templateName;

    if (this.isDuplicateTemplateName(header.name)) {
      this._toastr.error(
        "Template name already exists. Use a different name.",
        "Error"
      );

      return;
    }

    const isZeroQuantity =
      this.servicesTemplateGrid.filteredServiceLines.filter(
        item =>
          !item.orderedPurchaseQuantityD365 ||
          item.orderedPurchaseQuantityD365 < 1
      );

    if (isZeroQuantity.length > 0) {
      this._toastr.error("Error", "ZERO quantity not allowed for Services");
      return;
    }
    const duplicateLineSet = this.checkDuplicateItem([
      ...this.finishedGoodsTemplateGrid.filteredFinishedGoodsList,
    ]);

    if (duplicateLineSet.size > 0) {
      this._toastr.error(
        "Error",
        `Duplicate item variants: ${[...duplicateLineSet].join("; ")}.`
      );
      return;
    }

    const lines = [
      ...this.finishedGoodsTemplateGrid.filteredFinishedGoodsList,
      ...this.servicesTemplateGrid.filteredServiceLines,
    ];

    const linesTemplate = [];
    for (const line of lines) {
      line.id = 0;
      line.requestedDeliveryDateD365 = null;
      line.requestedShippingDateD365 = null;
      const templateLine = { ...line };
      linesTemplate.push(templateLine);
    }

    const request = {
      finishedGoodsTemplateHeader: header,
      finishedGoodsTemplateLines: linesTemplate,
    } as AddAndUpdateFinishedGoodsTemplateDto;

    this._loader.setLoaderState(true);
    this._inventoryPurchaseService
      .addAndUpdateFinishedGoodsTemplate(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loader.setLoaderState(false);
          if (res.data) {
            this._toastr.success("Template Created", "Success");
            this.selectedTemplate = {
              id: res.data,
              name: this.header.name,
            } as FinishedGoodsTemplateHeader;

            this.templates.push(this.selectedTemplate);
            this.finishedGoodsTemplateGrid.filteredFinishedGoodsList = [];
            this.servicesTemplateGrid.filteredServiceLines = [];
            this.ngOnInit();
            this.getFinishedGoodsTemplate();
          } else {
            this._toastr.error("Error while creating template", "Error");
          }
        },
        error: () => {
          this._loader.setLoaderState(false);
          this._toastr.error(
            "Something went wrong while creating template",
            "Error"
          );
        },
      });
  }

  isDuplicateTemplateName(name: string) {
    const template = this.allTemplates.find(x => x.name === name);
    if (template) {
      return true;
    }
    return false;
  }

  checkDuplicateItem(lines: PurchaseOrderLine[]): Set<string> {
    const itemMap = new Map<string, number>();
    const duplicateItemNumber = new Set<string>();
    for (const line of lines) {
      if (line.itemNumberD365) {
        if (!line.colorD365) {
          line.colorD365 = "";
        }
        if (!line.sizeD365) {
          line.sizeD365 = "";
        }
        if (!line.styleD365) {
          line.styleD365 = "";
        }

        if (
          itemMap.get(
            `${line.itemNumberD365}${line.styleD365}${line.sizeD365}${line.colorD365}`
          )
        ) {
          duplicateItemNumber.add(line.itemNumberD365);
        } else {
          itemMap.set(
            `${line.itemNumberD365}${line.styleD365}${line.sizeD365}${line.colorD365}`,
            (itemMap.get(
              `${line.itemNumberD365}${line.styleD365}${line.sizeD365}${line.colorD365}`
            ) ?? 0) + 1
          );
        }
      }
    }

    return duplicateItemNumber;
  }

  overWriteTemplate() {
    const header = this.header;
    header.vendorReference = this.vendorReference;
    header.name = this.templateName;

    const duplicateLineSet = this.checkDuplicateItem([
      ...this.finishedGoodsTemplateGrid.filteredFinishedGoodsList,
    ]);

    if (duplicateLineSet.size > 0) {
      this._toastr.error(
        "Error",
        `Item Numbers: ${[...duplicateLineSet].join(", ")} are duplicate`
      );
      return;
    }

    const isZeroQuantity =
      this.servicesTemplateGrid.filteredServiceLines.filter(
        item =>
          !item.orderedPurchaseQuantityD365 ||
          item.orderedPurchaseQuantityD365 < 1
      );

    if (isZeroQuantity.length > 0) {
      this._toastr.error("Error", "ZERO quantity not allowed for Services");
      return;
    }

    const lines = [
      ...this.finishedGoodsTemplateGrid.filteredFinishedGoodsList,
      ...this.servicesTemplateGrid.filteredServiceLines,
    ];

    const linesTemplate = [];
    for (const line of lines) {
      line.requestedDeliveryDateD365 = null;
      line.requestedShippingDateD365 = null;
      const templateLine = { ...line };
      linesTemplate.push(templateLine);
    }

    const request = {
      finishedGoodsTemplateHeader: header,
      finishedGoodsTemplateLines: linesTemplate,
    } as AddAndUpdateFinishedGoodsTemplateDto;

    this._loader.setLoaderState(true);
    this._inventoryPurchaseService
      .addAndUpdateFinishedGoodsTemplate(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loader.setLoaderState(false);
          if (res.data) {
            this._toastr.success("Template updated", "Success");
          } else {
            this._toastr.error("Error while creating template", "Error");
          }
        },
        error: () => {
          this._loader.setLoaderState(false);
          this._toastr.error(
            "Something went wrong while creating template",
            "Error"
          );
        },
      });
  }

  createLineGroup() {
    if (this.finishedGoodsTemplateGrid.filteredFinishedGoodsList.length > 0) {
      this.finishedGoodsTemplateGrid.filteredFinishedGoodsList =
        this.finishedGoodsTemplateGrid.filteredFinishedGoodsList.map(item => {
          return {
            ...item,
            mockSellD365: 0,
            mockSellTotalD365: 0,
            purchasePriceD365: item.purchasePriceD365 ?? 0,
            lineAmountD365: item.lineAmountD365 ?? 0,
          };
        });
    }
    this.calculateNet();

    const isZeroQuantity =
      this.servicesTemplateGrid.filteredServiceLines.filter(
        item =>
          !item.orderedPurchaseQuantityD365 ||
          item.orderedPurchaseQuantityD365 < 1
      );

    if (isZeroQuantity.length > 0) {
      this._toastr.error("Error", "ZERO quantity not allowed for Services");
      return;
    }

    const lines = [
      ...this.finishedGoodsTemplateGrid.filteredFinishedGoodsList,
      ...this.servicesTemplateGrid.filteredServiceLines,
    ];

    // const duplicateLineSet = this.checkDuplicateItem([
    //   ...this.finishedGoodsTemplateGrid.filteredFinishedGoodsList
    // ]);

    // if (duplicateLineSet.size > 0) {
    //   this._toastr.error(
    //     'Error',
    //     `Item Numbers: ${[...duplicateLineSet].join(', ')} are duplicate`
    //   );
    //   return;
    // }

    for (const line of lines) {
      line.siteD365 = this.site;
      line.lineGroupD365 = this.lineGroup;
      line.warehouseD365 = this.warehouse;
      line.purchaseOrderNumberD365 = this.saleOrderIdFromModal;
      line.jobNameD365 = this.jobNameD365;
      line.wMSLocationD365 = this.wMSLocationD365;
      line.purchaseUnitSymbolD365 = "ea";
      line.requestedDeliveryDateD365 = null;
      line.requestedShippingDateD365 = null;
      line.id = 0;
    }

    if (!lines?.length) {
      this._toastr.error(
        "No new Lines Found in the line group to add",
        "Error"
      );
      return;
    }

    this._loader.setLoaderState(true);
    if (lines.length > 0) {
      lines.forEach((value: PurchaseOrderLine) => {
        value.rsmFirmD365 = value.rsmFirmD365?.toString() ?? "false";
      });
    }
    this._samplepoListingService.addLineGroup(lines).subscribe({
      next: res => {
        this._loader.setLoaderState(false);
        if (res.status.toLowerCase() === "success") {
          this._toastr.success(res.message, "Success");
          this.closeModal();
          return;
        }

        this._toastr.error(res.message, "Error");
      },
      error: () => {
        this._loader.setLoaderState(false);
      },
    });
  }

  serviceLines(lines: PurchaseOrderLine[]) {
    this.servicesTemplateGrid.filteredServiceLines.push(...lines);
    // this._toastr.success("Success", "Line Added Successfully");
  }

  closeModalFromInventoryServiceLines() {
    this.inventoryServiceLinesDisplayModal = false;
  }

  addNewServiceLine() {
    this.index = null;

    this.serviceLineToEdit = {} as PurchaseOrderLine;
    this.inventoryServiceLinesDisplayModal = true;
  }

  editServiceLine([line, index]: [PurchaseOrderLine, number]) {
    this.serviceLineToEdit = line;
    this.index = index;
    this.inventoryServiceLinesDisplayModal = true;
  }

  editedServiceLine([lines]: [PurchaseOrderLine]) {
    if (this.index != null) {
      this.servicesTemplateGrid.filteredServiceLines[this.index] = lines;
      this.serviceLineToEdit = {} as PurchaseOrderLine;
    }
  }

  closeModal() {
    this.closeModalEmit.emit();
    this.refreshGridEmit.emit();
  }

  calculateNet() {
    if (!this.selectedTemplate) {
      this._toastr.error("No Finished Good template selected.", "Error");
    }
    let sumOfLineAmount = 0;
    this.servicesTemplateGrid.filteredServiceLines
      .filter(x => !x.excludedD365)
      .forEach(x => {
        if (x.currencyCodeD365?.toLowerCase() == "usd") {
          sumOfLineAmount = sumOfLineAmount + (x.lineAmountD365 ?? 0);
        } else {
          sumOfLineAmount = x.amountInTransactionCurrency
            ? sumOfLineAmount + (x.amountInTransactionCurrency ?? 0)
            : sumOfLineAmount + (x.lineAmountD365 ?? 0);
        }
      });

    let totalQuantity = 0;
    this.finishedGoodsTemplateGrid.filteredFinishedGoodsList.forEach(
      x =>
        (totalQuantity = totalQuantity + (x.orderedPurchaseQuantityD365 ?? 0))
    );

    this.finishedGoodsTemplateGrid.filteredFinishedGoodsList.forEach(x => {
      this.finishedGoodsTemplateGrid.onNetConversion(
        (sumOfLineAmount / totalQuantity).toString(),
        x
      );
    });
  }

  setTemplateName() {
    // const name = this.templateName;

    // // regular expression to match the last occurrence of the word
    // const result = name.replace(
    //   new RegExp(
    //     `${this.templateVendorReference}(?!.*${this.templateVendorReference})`
    //   ),
    //   ''
    // );

    const result = this.oldTemplateName.replace(
      new RegExp(
        `${this.templateVendorReference}(?!.*${this.templateVendorReference})`
      ),
      ""
    );

    this.templateName = this.vendorReference
      ? `${result}${result[result?.length - 1] == "-" ? "" : "-"}${
          this.vendorReference
        }`
      : `${result}`;
  }

  filterTemplates() {
    if (this.size || this.color || this.fit) {
      if (this.size) {
        this.templates = this.allTemplates.filter(x => x.size);
      }
      if (this.color) {
        this.templates = this.allTemplates.filter(x => x.color);
      }
      if (this.fit) {
        this.templates = this.allTemplates.filter(x => x.fit);
      }
    } else {
      this.templates = this.allTemplates;
    }
  }

  deleteTemplateDialogBox() {
    this.confirmationService.confirm({
      message: "Do you want to delete the existing template?",
      acceptLabel: "Yes",
      rejectLabel: "No",
    });
  }

  deleteTemplate() {
    const templateHeaderId = {
      headerIds: [this.selectedTemplate.id],
    } as DeleteTemplateDto;
    this._loader.setLoaderState(true);
    this._inventoryPurchaseService
      .deleteTemplate(templateHeaderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loader.setLoaderState(false);
          if (res.data) {
            this._toastr.success(res.message, "Success");
            this.getFinishedGoodsTemplateNames();
            this.resetForms();
          }
        },
        error: () => {
          this._loader.setLoaderState(false);
          this._toastr.error(
            "Something went wrong while fetching templates",
            "Error"
          );
        },
      });
  }

  resetForms() {
    this.selectedTemplate = {} as FinishedGoodsTemplateHeader;
    this.templateName = "";
    this.size = false;
    this.fit = false;
    this.color = false;
    this.vendorReference = "";
    this.finishedGoodsTemplateGrid.filteredFinishedGoodsList = [];
    this.servicesTemplateGrid.filteredServiceLines = [];
    this.header = {} as FinishedGoodsTemplateHeader;
    this.itemType = "";
    this.oldTemplateName = "";
    this.templateVendorReference = "";
    this.vendorReference = "";
  }

  dialogBoxButtonEvent(event: number) {
    switch (event) {
      case 1:
        this.deleteTemplate();
        break;

      case 2:
        break;

      default:
        break;
    }

    this.confirmationService.close();
  }
}
